<template>
  <div class="accordion">
    <div
      class="carousel"
      @mousemove="dragging"
      @mousedown="dragStart"
      @mouseup="dragStop"
      @mouseleave="dragStop"
      @touchstart="dragStart"
      @touchmove="dragging"
      @touchend="dragStop"
      ref="videoSliderRef"
    >
      <UiBlocksWithPriceCardWithPriceV1
        v-for="(item, index) in items"
        :key="item.id"
        :item="item"
        :positionBgLeft="oneImgBg ? 100 / items.length : null"
        :positionBgLeftIndex="oneImgBg ? index : null"
        ref="videoFirstRef"
        :class="{
          'gallery-video-loop_first': index === 0,
          'gallery-video-loop': true,
        }"
        @click="clickHandler"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import {useBaseStore} from '~/modules/BaseModule/base.store';

const props = withDefaults(
  defineProps<{
    oneImgBg?: boolean;
    items: {
      id: number;
      img: string;
      title: string;
      subtitle: string;
      hiddenTextTitleForLi?: string;
      hiddenText: string | string[];
    }[];
  }>(),
  {},
);

const emits = defineEmits(['chooseItem']);

const base = useBaseStore();
const isMobile = computed(() => base.isMobile);
const videoSliderRef = ref(null);
const videoFirstRef = ref(null);

let positionDiff: number;
let firstImgWidth: number;
let isDragStart = false;
let prevPageX: number;
let prevScrollLeft: number;
let scrollWidth: number;
let isDragging = false;

const clickHandler = () => {
  if (!isDragging) {
    emits('chooseItem', '');
  }
};

const dragging = (e) => {
  if (videoSliderRef.value) {
    if (!isDragStart) return;
    // e.preventDefault();
    isDragging = true;
    videoSliderRef.value.classList.add('dragging');
    positionDiff = (e.pageX || e.touches[0].pageX) - prevPageX;
    videoSliderRef.value.scrollLeft = prevScrollLeft - positionDiff;
  }
};

const dragStart = (e) => {
  if (videoSliderRef.value) {
    isDragStart = true;
    prevPageX = e.pageX || e.touches[0].pageX;
    prevScrollLeft = videoSliderRef.value.scrollLeft;
  }
};
const dragStop = (e) => {
  isDragStart = false;
  if (videoSliderRef.value) {
    videoSliderRef.value.classList.remove('dragging');
    if (!isDragging) return;
    setTimeout(() => {
      isDragging = false;
    }, 0);
  }
};

watch(
  () => [isMobile.value],
  () => {
    if (videoSliderRef.value) {
      videoSliderRef.value.scrollLeft = 0;
      setTimeout(() => {
        const additionalValueML = isMobile.value ? 8 : 8;
        firstImgWidth =
          videoSliderRef.value.clientWidth + additionalValueML;
        scrollWidth =
          videoSliderRef.value.scrollWidth -
          videoSliderRef.value.clientWidth;
      }, 100);
    }
  },
);

const resizeHandler = () => {
  if (videoFirstRef.value) {
    const additionalValueML = isMobile.value ? 8 : 8;
    firstImgWidth =
      videoSliderRef.value.clientWidth + additionalValueML;
  }
};

onMounted(() => {
  if (videoSliderRef.value) {
    const additionalValueML = isMobile.value ? 8 : 8;
    firstImgWidth =
      videoSliderRef.value.clientWidth + additionalValueML;
    scrollWidth =
      videoSliderRef.value.scrollWidth -
      videoSliderRef.value.clientWidth;
  }

  window.onresize = resizeHandler;
});
onUnmounted(() => {
  window.onresize = null;
});
</script>

<style scoped lang="scss">
.accordion {
  display: flex;
  gap: $g-2;

  @media (max-width: $md) {
    flex-direction: column;
  }
}

.carousel {
  width: 100%;
  overflow: hidden;
  scroll-behavior: smooth;
  display: flex;
  cursor: pointer;
  gap: 16px;

  @media (max-width: $lg) {
    flex-direction: column;
  }

  .card-price {
    width: 100%;
    min-width: 234px;
    @media (max-width: $lg) {
      width: calc(100% / 1);
    }
    @media (max-width: $md) {
      min-width: 89vw;
      width: calc(100% / 1);
      height: 100%;
    }

    &__one-img {
      @media (max-width: $md) {
        min-width: 234px !important;
      }
    }
  }

  //.gallery-video-loop {
    //margin-left: 8px;
    //&_first {
    //  margin-left: 0px;
    //}

    //@media (max-width: $md) {
    //  margin-left: 8px;
    //  &_first {
    //    margin-left: 0px;
    //  }
    //}
  //}
}
.dragging {
  scroll-behavior: auto;

  .card-review {
    pointer-events: none;
    cursor: grab !important;
  }
}

.dragging {
  .card-review {
    cursor: grabbing !important;
  }
}
</style>
